<template>
    <modal-base :pacifier="false">
        <template #title>
            {{ titleText }}
        </template>

        <template #subtitle>Choose a date and time below:</template>
    </modal-base>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        mounted() {
            this.$store.commit('card', 'calendar');
        },

        computed: {
            titleText() {
                return this.hasScheduledCall
                    ? 'Reschedule Your Appointment'
                    : 'Schedule an Appointment With Your Unbundled Lawyer';
            },

            ...mapGetters([
                'hasScheduledCall',
            ])
        }
    }
</script>
